import { NotFound } from '@common/components/feedback/NotFound';
import { Layout } from '@common/components/layout/Layout';
import { AzureCallback, LoginPage, ProtectedRoute } from '@features/auth';
import { CampanhaDetalhePage, CampanhasPage } from '@features/campanhas';
import { FormularioPage, ResponderPage } from '@features/formulario';
import { InicioPage } from '@features/inicio';
import { UsuariosPage } from '@features/usuarios';
import { NuqsAdapter } from 'nuqs/adapters/react-router/v7';
import { createBrowserRouter, Outlet } from 'react-router-dom';

function RootLayout() {
  return (
    <NuqsAdapter>
      <Outlet />
    </NuqsAdapter>
  );
}

export const router = createBrowserRouter([
  {
    element: <RootLayout />,
    children: [
      { path: '/login', element: <LoginPage /> },
      { path: '/auth/azure/callback', element: <AzureCallback /> },
      {
        element: <ProtectedRoute />,
        children: [
          {
            element: <Layout />,
            children: [
              { index: true, element: <InicioPage /> },
              { path: 'responder', element: <ResponderPage /> },
              { path: 'responder/:campanhaId', element: <FormularioPage /> },
              {
                element: <ProtectedRoute allowedRoles={['administrador']} />,
                children: [
                  { path: 'campanhas', element: <CampanhasPage /> },
                  { path: 'campanhas/:id', element: <CampanhaDetalhePage /> },
                  { path: 'usuarios', element: <UsuariosPage /> },
                ],
              },
            ],
          },
        ],
      },
      { path: '*', element: <NotFound /> },
    ],
  },
]);
